import {
  calcIdentityUrlPrefix,
  parseYWRUrl,
  SWRObjectKey,
} from "@/features/ui/helpers/fetcher-helpers";
import { IdentityParameter } from "@/features/types";
import { AxiosRequestConfig } from "axios";
import { singularizeCompanyType } from "@/features/ui/helpers/identity-helpers";

export interface GetOrderSheetRevisionV2Request {
  lineSheetSetId: number;
}

export interface GetOrderSheetRevisionV2PathParameter extends IdentityParameter {
  orderSheetSetId: number;
  revisionNumber: number;
}

export function getOrderSheetRevisionV2Key(
  parameter: GetOrderSheetRevisionV2PathParameter,
  request: GetOrderSheetRevisionV2Request
): SWRObjectKey<GetOrderSheetRevisionV2Request> {
  const { orderSheetSetId, revisionNumber } = parameter;
  let url = calcIdentityUrlPrefix(parameter);
  url += `/order-sheet-sets/${orderSheetSetId}/revisions/${revisionNumber}`;
  return {
    url,
    params: request,
  };
}

// TODO: 이건 위 함수와 거의 비슷한 것 같은데 왜 분리해둔걸까?
export function parseGetOrderSheetRevisionV2Key(
  key: AxiosRequestConfig<GetOrderSheetRevisionV2Request>
): {
  parameter: GetOrderSheetRevisionV2PathParameter;
  request: GetOrderSheetRevisionV2Request;
} {
  const { url, params } = key;
  const obj = parseYWRUrl(
    "/:companyType/:companyId/order-sheet-sets/:orderSheetSetId/revisions/:revisionNumber",
    url!!
  );

  const parameter: GetOrderSheetRevisionV2PathParameter = {
    by: singularizeCompanyType(obj["companyType"]),
    companyId: parseInt(obj["companyId"]),
    orderSheetSetId: parseInt(obj["orderSheetSetId"]),
    revisionNumber: parseInt(obj["revisionNumber"]),
  };

  return {
    parameter,
    request: key.params!!,
  };
}
